<template>

  <div class="content content-fixed content-auth-alt">
    <div class="container d-flex justify-content-center ht-100p">
      <div class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center">
        <div class="wd-80p wd-sm-300 mg-b-15"><img src="http://themepixels.me/demo/dashforge2/assets/img/img18.png" class="img-fluid" alt=""></div>
        <h4 class="tx-20 tx-sm-24">Reset your password</h4>
        <p class="tx-color-03 mg-b-30 tx-center">Enter your username or email address and we will send you a link to reset your password.</p>
        <div class="wd-100p d-flex flex-column flex-sm-row mg-b-40">
          <input v-model="email" type="text" class="form-control wd-sm-250 flex-fill" placeholder="Enter username or email address">
          <button v-on:click="forgotPassword" class="btn btn-brand-02 mg-sm-l-10 mg-t-10 mg-sm-t-0">Send Reset Link</button>
        </div>
        <span class="tx-12 tx-color-03">CLick here to <a href="/login"> Login </a></span>

      </div>
    </div><!-- container -->
  </div><!-- content -->

  <AuthFooter/>



</template>


<script>
import AuthFooter from "./AuthFooter.vue";

export default {
  name: "ForgotPassword",
  components: {AuthFooter},
  data() {
    return {
      passwordReport: "",
      email: "",
    };
  },
  methods: {
    async forgotPassword() {
      try {
        let result = await this.$axios.post(`${this.authServer}/forgot-password`, {
          email: this.email,
          organizationAppId: this.orgAppId
        });
        console.log(result)
        this.passwordReport = 'Please check your email for password reset link'
      } catch (error) {
        if (error.response) {
          // Pass error response to UI
          this.$router.push({
            path: "error",
            query: {code: error.response.data.errorCode, message: error.response.data.errorMessage},
          });
        }
      }
    },
  },
  mounted() {
    let user = localStorage.getItem("user-info");
    if (user) {
      this.$router.push({name: "Home"});
    }
  },
};
</script>
